import { ReactElement } from "react";
import {
  IContentAreaProps,
  IDataContext,
  IIndicator,
  IMenuButton,
  IViewController,
} from "../../types";
import BarChartIndicator from "./components/indicators/barChart";
import GeneralDashboard from "./components/generalDashboard";
import Consolidate from "./components/indicators/consolidate";
import DashboardIcon from "@mui/icons-material/Dashboard";


class Module implements IViewController {

  private ganttButton: IMenuButton = {
    title: "Dashboard",
    icon: <DashboardIcon/>,
    color: "cyan",
    dataContext: {
      title: "Dashboard",
      module: "general",
      subModule: "general/dashboard"
    }
  };

  private buttons = [ this.ganttButton ];

  getModuleName(): string{
    return "general";
  }

  getView(dataContext: IDataContext, props: IContentAreaProps): ReactElement {
    if (dataContext.subModule === "general/dashboard") {
      return <GeneralDashboard parentSize={props.parentSize}/>;
    }

    return <div />;
  }

  getButtons(): IMenuButton[] {
    return [];
  }

  getButton(subModule: string): IMenuButton | undefined {
    return this.buttons.find(x => x.dataContext && x.dataContext.subModule === subModule);
  }

  getIndicator(dataContext: IIndicator): ReactElement | undefined {
    if (dataContext.component === "barChart") {
      return <BarChartIndicator dataContext={dataContext} />;
    }

    if (dataContext.component === "consolidate") {
      return <Consolidate dataContext={dataContext} />;
    }

    return undefined;
  }
}

const instance = new Module();

export default instance;
